import axios from "axios";
import { config } from "../../config";
import { loginApiPath } from "../paths";

export const fetchLogin = (): Promise<{}> =>
  new Promise(async (resolve, reject) => {
    try {
      const res = await axios.get(loginApiPath, {
        baseURL: config.baseURL,
      });

      resolve(res.data);
    } catch (e) {
      reject(e);
    }
  });
